export enum Routes {
  UpdatePlan = 'user/package',
}
